import { PulsingLogo } from './PulsingLogo'

/* AppLoadingWidget: Align(0,0) -> pulsing 200x200 logo. The component fills
 * its parent and centres the logo, mirroring the Align. */

export function AppLoading() {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <PulsingLogo />
    </div>
  )
}
